import { render } from "./AbilityEditSideBySide.vue?vue&type=template&id=7711490c&lang=true"
import script from "./AbilityEditSideBySide.vue?vue&type=script&lang=js"
export * from "./AbilityEditSideBySide.vue?vue&type=script&lang=js"
script.render = render

export default script